import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';
import { withModal } from 'components/modal/ModalHOC';

import CampaignPayoutsVariablePaymentsModal from '../../modals/variable-payments/CampaignPayoutsVariablePaymentsModal';

import { renderPrice } from 'utils/helper/price';
import { __t, applyTranslations } from 'utils/language';

import './campaign-payouts-header-variable.scss';

import type { PaymentCampaignBudget, PaymentInfo, SubcampaignInfluencerProfile, VariablePayment } from 'types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./campaign-payouts-header-variable.i18n.json'));

type MONETARY_TYPE = 'agreed' | 'variable';

type Props = {
  campaignName: string,
  subcampaignId: number,
  influencerProfile: SubcampaignInfluencerProfile,
  paymentInfo: PaymentInfo,
  variablePayments: Array<VariablePayment>,
  otherArrangement: boolean,
  isLoading: boolean,
  campaignBudgetInfo: PaymentCampaignBudget,
  onCreateVariablePayments: (b: number, a: Array<VariablePayment>) => void,
  onEditVariablePayments: (b: number, a: Array<VariablePayment>) => void
};

const MSG_KEY = 'campaign_payouts_header_variable';

const TooltipWithEditModal = withModal(Tooltip, {
  modalContent: CampaignPayoutsVariablePaymentsModal
});

class CampaignPayoutsHeaderVariable extends React.PureComponent<Props> {
  getNoValueText(type: MONETARY_TYPE): string {
    const { otherArrangement } = this.props;

    return otherArrangement && type === 'agreed'
      ? __t('campaign_payouts_header_variable.labels.other_arrangement')
      : '—';
  }

  renderEditIcon(): React.ReactNode {
    const {
      campaignName,
      campaignBudgetInfo,
      subcampaignId,
      influencerProfile,
      variablePayments,
      paymentInfo,
      otherArrangement,
      isLoading,
      onCreateVariablePayments,
      onEditVariablePayments
    } = this.props;

    return (
      <div className="campaign-payouts-header-variable__icon">
        <TooltipWithEditModal
          modalContentProps={{
            campaignName,
            campaignBudgetInfo,
            subcampaignId,
            variablePayments,
            paymentInfo,
            influencerProfile,
            otherArrangement,
            isLoading,
            onCreateVariablePayments,
            onEditVariablePayments
          }}
          message={__t('collabary_common.basics.edit')}
          width="micro"
        >
          <SVGDynamicIcon
            name="pencil-custom-bg"
            width={13}
            height={12}
            customColor="grey"
            clickable
          />
        </TooltipWithEditModal>
      </div>
    );
  }

  renderPaymentValue(type: MONETARY_TYPE): React.ReactNode {
    const { paymentInfo } = this.props;
    const value = paymentInfo.amounts[type] || 0;
    const label = __t(`${MSG_KEY}.labels.${type}_payment`);

    const updatedValue = renderPrice(value, { defaultValue: this.getNoValueText(type) });

    return (
      <div className="campaign-payouts-header-variable__display">
        <div
          className="campaign-payouts-header-variable__label"
          title={`${label}: ${updatedValue}`}
        >
          {__t(`${MSG_KEY}.labels.${type}_payment`)}:
        </div>
        <div
          className="campaign-payouts-header-variable__value"
          title={`${label}: ${updatedValue}`}
        >
          <div>
            {updatedValue}
          </div>
          {
            type === 'variable' &&
              this.renderEditIcon()
          }
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="campaign-payouts-header-variable">
        {this.renderPaymentValue('agreed')}
        {this.renderPaymentValue('variable')}
      </div>
    );
  }
}

export default CampaignPayoutsHeaderVariable;
